import { render } from "./App.vue?vue&type=template&id=830b014c"
const script = {}

import exportComponent from "/Users/johnny/express-vue3-tailwind-map/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__